import { allParents, parentTreeItem } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { cleanLabel } from "routes/regime/plugins/regime-search/lib/search-labels.mjs"
import { iconForBreadcrumbType, iconForResult } from "routes/regime/plugins/regime-search/lib/search-icons.js"

export const REGIMES_GROUP = "Maintenance Regimes"
export const REGIMES_GROUP_BREADCRUMBS = [{ label: REGIMES_GROUP, icon: iconForBreadcrumbType("regime") }]

export function breadcrumbsFor(searchResult) {
    if (searchResult.isAsset) return (searchResult.breadcrumbs ?? []).map(typedBreadcrumb)
    if (searchResult[PlanRoot]) return []
    return allParents(searchResult[parentTreeItem], isNotPlanRoot).map(nodeBreadcrumb).filter(hasLabel).reverse()
}

export function groupLabelFrom(breadcrumbs) {
    return breadcrumbs.map(breadcrumbLabel).join(" › ") || REGIMES_GROUP
}

function breadcrumbLabel(breadcrumb) {
    return breadcrumb.label
}

function typedBreadcrumb(breadcrumb) {
    return { label: breadcrumb.label, icon: iconForBreadcrumbType(breadcrumb.type), id: breadcrumb.id }
}

function nodeBreadcrumb(node) {
    return {
        label: cleanLabel(node.label ?? node.data?.name),
        icon: node[PlanRoot] ? iconForBreadcrumbType("regime") : iconForResult(node),
        id: node.id,
    }
}

function isNotPlanRoot(treeItem) {
    return !treeItem[PlanRoot]
}

function hasLabel(breadcrumb) {
    return !!breadcrumb.label
}
